"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEmployeeCardFooterContent = void 0;
const react_dom_1 = require("react-dom");
const employee_card_context_1 = require("../employee-card-context");
const react_1 = __importDefault(require("react"));
const util_1 = require("@app/util");
const useEmployeeCardFooterContent = (content) => {
    const { footerExtraContentTarget } = (0, employee_card_context_1.useEmployeeCard)();
    const displayContent = react_1.default.useCallback(() => {
        if ((0, util_1.isNull)(footerExtraContentTarget))
            return null;
        return (0, react_dom_1.createPortal)(content, footerExtraContentTarget);
    }, [content, footerExtraContentTarget]);
    return { displayContent };
};
exports.useEmployeeCardFooterContent = useEmployeeCardFooterContent;
